module.exports = __webpack_public_path__ + "/c891b1f24e7bbfec1a4685ecd3c99b2f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/audit_trail_icon.svg
 ** module id = 1633
 ** module chunks = 0
 **/